import { render, staticRenderFns } from "./Ephemera.vue?vue&type=template&id=1d6543d1&scoped=true&"
import script from "./Ephemera.vue?vue&type=script&lang=js&"
export * from "./Ephemera.vue?vue&type=script&lang=js&"
import style0 from "./Ephemera.vue?vue&type=style&index=0&id=1d6543d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6543d1",
  null
  
)

export default component.exports